module.exports = "span {\n  line-height: 26px;\n  padding-left: 11px;\n}\n"